export default {
  props: ["image", "alt_image", "title", "price", "route", "slug"],
  data: () => ({
    showButton: window.innerWidth >= 1280
  }),
  methods: {
    goToDestiny() {
      this.$router.push({ name: "destiny", params: { slug: this.slug } });
    }
  }
};
